import InnoIcons from "InnoUI/innoicons";
import React from "react";
import theme from "@theme";

const priorityColor = theme.priorityColor;

const PriorityComponent = ({ value, sx }) => {
  const getIconComponent = () => {
    const priorityId = String(value?.id);
    switch (priorityId) {
      case "20": //
        return (
          <InnoIcons.Low
            sx={{
              ...sx,
              color: priorityColor.Low,
              fontWeight: "bold",
              fontSize: "large",
            }}
          />
        );
      case "30":
        return (
          <InnoIcons.Normal
            sx={{
              ...sx,
              color: priorityColor.Normal,
              fontWeight: "bold",
              fontSize: "large",
            }}
          />
        );
      case "40":
        return (
          <InnoIcons.High
            sx={{
              ...sx,
              color: priorityColor.High,
              fontWeight: "bold",
              fontSize: "large",
            }}
          />
        );
      default:
        return null;
    }
  };

  return getIconComponent();
};

export default PriorityComponent;
